import { IObjektVy } from '../../../../../Types/ObjektVy';
import { standardVy, objektLänk } from '../../../../../Utils/ObjektVyUtils';
import ObjektVySida from '../../../_Common/Components/BusinessCollectionComponents/ObjectVySida';
import { objektVyGrupp } from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyGrupp';
import { useBetalningFunktionsMenyItems } from './useBetalningFunktionsMenyItems';

const forstaSida: IObjektVy = ObjektVySida('standard', [
  [
    objektVyGrupp(
      'forstaSida',
      [
        'UTBET_DATUM',
        'PLAN_UTBET_DATUM',
        'BELOPP',
        'VALUTA_BELOPP',
        'STATUS',
        objektLänk('Utbetalningssatt'),
        objektLänk('Betalningsuppdrag'),
      ],
      ' '
    ),
  ],
]);

const standard: IObjektVy = standardVy([forstaSida], {
  useFunktionsMenyItems: useBetalningFunktionsMenyItems,
});

export const Betalningsvyer: IObjektVy[] = [standard];
